import React from 'react';
import PropTypes from 'prop-types';
import { InternalGrid, Text, Toggle } from '@paygreen/paygreen-ui';
import { useMode } from '../../context/useMode';
import { useTranslation } from 'react-i18next';
import { MODES } from '../../utils/constants';

const ToggleMode = ({ externalChange }) => {
    const { mode, handleSetMode } = useMode();
    const { t } = useTranslation();

    const handleToggle = (e) => {
        handleSetMode(e.target.checked ? MODES.PROD : MODES.TEST);
        externalChange && externalChange();
    };

    return (
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto auto"
            gridGap="md"
            alignItems="center"
            childrenMarginBottom="xs"
        >
            <Text colorWab="grey30">{t('mode.displayedData')}</Text>

            <Toggle
                id="toggle"
                checkedLabel={t('mode.prod')}
                notCheckedLabel={t('mode.test')}
                checked={mode === MODES.PROD}
                value={mode === MODES.PROD}
                onChange={handleToggle}
            />
        </InternalGrid>
    );
};

ToggleMode.propTypes = {
    externalChange: PropTypes.func,
};

export default ToggleMode;
